import React from 'react'

export const ProjectStackCard = ({item}) => {
  return (
    <div class="project-stack">
        <p>
            <em>{item}</em>
        </p>
    </div>
  )
}
